
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'office-ui-fabric-react/lib/Link';

import { getParcelaCislo } from '../../common/common/iskn/parcela';

import infoGetActions from '../../sagas/info';

const LinkToParcela = (props) => {

    const dispatch = useDispatch();
    const infoActions = infoGetActions(dispatch);

    const token = useSelector(state => {
        return state.auth.data ? state.auth.data.user.token : null;
    });

    const projectId = useSelector(state => {
        return state.project.data.project.id;
    });

    const handleClick = () => {
        infoActions.getObjectParcela(token, projectId, props.parc.id);
    }

    return (
        <Link onClick={handleClick} title="Zobrazit informace o parcele">{getParcelaCislo(props.parc)}</Link>
    )
}

export default LinkToParcela;
